export default "__VITE_ASSET__CjbRmXKr__"